import { render, staticRenderFns } from "./ArticleInfoGoogleFrefered.vue?vue&type=template&id=4bc83ba1&scoped=true"
import script from "./ArticleInfoGoogleFrefered.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoGoogleFrefered.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoGoogleFrefered.vue?vue&type=style&index=0&id=4bc83ba1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc83ba1",
  null
  
)

export default component.exports